import React, { useMemo } from 'react'
import ReactDOM from 'react-dom'
import { Spinner } from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import { Modal, notification, Tooltip } from 'antd'
import { Formik, isFunction } from 'formik'
import { compose } from 'redux'

import Dialog from 'components/platform/Dialog'
import { Button } from 'components/platform/buttons/Button'
import apiClient from 'services/api'
import withSocket from '../withSocket'
import differences from '../../utils/differences'
import { HeaderTitle } from '../../Pages'
import { withRemoteActions } from '../withRemoteActions'

import './style.scss'

export const resourceClient = {
  getItems: (url, config) => apiClient.get(`${url}`, config),
  getItem: (url, id, params) => apiClient.get(`${url}/${id}`, { params }),
  deleteItem: (url, id) => apiClient.delete(`${url}/${id}`, { params: {} }),
  updateItem: (url, id, data) => apiClient.put(`${url}/${id}`, data),
  patchItem: (url, id, data) =>
    apiClient.patch(`${url}/${id}`, data, {
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
    }),
  createItem: (url, data) => apiClient.post(`${url}`, data),
  saveItem: (url, withPatch, { id, ...data }) => {
    if (id) {
      return withPatch
        ? resourceClient.patchItem(url, id, data)
        : resourceClient.updateItem(url, id, data)
    }
    return resourceClient.createItem(url, data)
  },
}

const OnlineCounter = () => (
  <Tooltip title={'Il form è stato aperto'}>
    {<i style={{ cursor: 'pointer' }} className={'fa fa-circle text-warning'} />}
  </Tooltip>
)
const ExternalChanges = () => (
  <Tooltip title={'Modificato esternamente'}>
    {<i style={{ cursor: 'pointer' }} className={'fa fa-exclamation-triangle text-danger ml-2'} />}
  </Tooltip>
)

const { confirm } = Modal

/**
 * @param {*} title
 * @param {*} ok
 * @param {*} content
 * @param [onCancel]
 */
export function showDeleteConfirm(title, ok, content = 'Si per continuare', onCancel) {
  confirm({
    title,
    content,
    okText: 'SI',
    okType: 'danger',
    cancelText: 'No',
    onOk() {
      ok()
    },
    onCancel() {
      if (typeof onCancel === 'function') {
        onCancel()
      }
      console.log('Cancel')
    },
  })
}
const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message,
    placement: 'bottomRight',
    // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
  })
}
export const Message = {
  show: ({ data }) => {
    console.log(data)
    openNotificationWithIcon(data.error ? 'error' : 'success', data.message)
  },
}


const Div = props => <div>{props.children}</div>

const HeaderDialogTitle = ({ item, title }) => {
  const finalTitle = useMemo(() => {
    return isFunction(title) ? title({ item }) : title
  }, [title, item])
  return <HeaderTitle title={finalTitle} />
}

const SaveCloseButtonText = ({ item, text }) => {
  return useMemo(() => {
    return isFunction(text) ? text({ item }) : text
  }, [text, item])
}

export const withModalForm = ({
  source,
  apiResource,
  apiSaveUrl,
  apiGetItemParams = {},
  title = <FormattedMessage id={'global.no_title'} />,
  width = '95%',
  isPage = false,
  bodyStyle = null,
  dialogClass = undefined,
  rightButtons: LeftButtons,
  buttons: configButtons = {
    saveButton: false
  },
  rightContainer = true,
  confirmDeleteMessage,
  apiMethod = 'patch',
  savingFn,
  getExtraData = undefined,
  getItemValues = undefined,
  onSavedProjectCv = undefined
}) => FormWrapped => {

  const isFunctionComponent = typeof FormWrapped !== 'string' && !FormWrapped.prototype?.render

  // console.log("isFunctionComponent",isFunctionComponent,apiResource)

  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  const LastFormWrapped = isFunctionComponent ? React.forwardRef((props, ref) => (
    <FormWrapped {...props} />
  )) : FormWrapped

  class ModalForm extends React.Component {
    isPage = false

    roomName = null

    constructor(props) {
      super(props)
      if (isPage || this.props.match && this.props.match.params.itemId) {
        this.isPage = true
      }
      this.state = {
        width,
        clientCounter: 0,
        externalChanges: false,
      }
    }

    componentDidMount() {
      const id = this._getId()
      this.props.remote.loadItem(id)

      if (id && id > 0) {
        this.roomName = `modalform_${this.props._type}_${id}`
        this.props.socket.on(`${this.roomName}:clients_counter`, this._onSocketCounter)
        this.props.socket.on(`${this.roomName}:events`, this._onSocketEvents)
        this.props.socket.on('connect', this._joinRoom)
        this._joinRoom()
      }
    }

    componentWillUnmount() {
      if (this.roomName) {
        this.props.socket.off(`${this.roomName}:clients_counter`, this._onSocketCounter)
        this.props.socket.off(`${this.roomName}:events`, this._onSocketEvents)
        this.props.socket.off('connect', this._joinRoom)
        this.props.socket.emit('leave', {
          room: this.roomName,
        })
      }
    }

    _joinRoom = () => {
      console.log('_joinRoom', this.roomName)
      this.props.socket.emit('join', {
        room: this.roomName,
      })
    }

    _onSocketEvents = event => {
      console.log('_onSocketEvents', event)
      if (event.eventType === 'api:saved') {
        this.setState({ externalChanges: true })
      }
    }

    _onSocketCounter = counter => {
      this.setState({ clientCounter: counter })
    }

    _getId = () =>
      this.props.match && this.props.match.params.itemId
        ? this.props.match.params.itemId
        : this.props.itemId

    _save = () => {
      this._saveForm()
    }

    _saveClose = () => {
      this.closeModal = true
      this._saveForm()
    }

    _saveForm = async () => {
      if (this.modalForm?.saveForm) {
        this.modalForm.saveForm()
      } else {
        this.form.values.dataStart = this.form.values?.dataStart?.toString()
        this.form.values.dataEnd = this.form.values?.dataEnd?.toString()
        this.form.values.customer = this.form.values?.customer?.['@id'] || this.form.values?.customer;
        localStorage.setItem('metaIdCurriculum', this.form.values?.curriculum);
        await this.form.submitForm();
      }
    }

    _setWidth = dialogWidth => {
      this.setState({ width: dialogWidth })
    }

    _onSubmit = ({ values, closeModal, onSave }) => {

      const { remote } = this.props
      if (remote.item.id && apiMethod === 'patch') {
        values = differences(values, remote.item)
        values.id = remote.item.id
      }
      remote.saveItem(values, response => {
        // send event
        this.props.socket.emit('room_events', {
          room: this.roomName,
          eventType: 'api:saved',
          resource: response.data,
        })
        if (closeModal) {
          this.props.onClose()
        } else {
          this.form.setValues(response.data)
        }
        if (onSave) {
          onSave({ response })
        }
      })
    }

    render() {
      const { remote, buttons: propButtons = {}, ...rest } = this.props
      const { width: dialogWidth, clientCounter, externalChanges } = this.state
      const Container = this.isPage ? Div : Dialog

      const buttons = {
        ...configButtons,
        ...propButtons
      }

      const evaluateDelete = typeof buttons.evaluateDelete === 'function' ? buttons.evaluateDelete(remote.item) === false : false

      const header = (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div>
            <HeaderDialogTitle title={title} item={remote.item} />
          </div>
          {false && (
            <div>
              {clientCounter > 1 && <OnlineCounter counter={clientCounter} />}
              {externalChanges && <ExternalChanges />}
            </div>
          )}
          <div>
            {buttons.deleteButton === false || evaluateDelete || remote.loadingItem || !remote.item.id ? null : (
              <Button
                onClick={() => remote.deleteItem(remote.item.id, this.props.onClose)}
                color={"outline-danger"}
                className={"mr-2"}
                loading={remote.deletingItem}
              >
                {/* Elimina */}
                <FormattedMessage id={'global.delete'} />
              </Button>
            )}
            <Button
              onClick={() => this.props.onClose()}
              color={"outline-primary"}
              className={buttons.cancelClass || "mr-2"}
            >
              {buttons.cancelText || <FormattedMessage id={'global.close'} />}
            </Button>
            {(buttons.saveCloseButton === false || remote.loadingItem) ? null : (
              <Button
                color={"primary"}
                loading={remote.savingItem}
                onClick={this._saveClose}
                aria-label="Save"
              >
                {buttons.saveText ? <SaveCloseButtonText text={buttons.saveText} item={remote.item} /> : <FormattedMessage id={'global.save'} />}
              </Button>
            )}
            {
              buttons.saveButton === false || remote.loadingItem ? null : (
                <Button onClick={this._save} color={"primary"} loading={remote.savingItem}>
                  {/* Salva e continua */}
                  <FormattedMessage id={buttons.saveContinueText ? buttons.saveContinueText : 'global.save_continue'} />
                </Button>
              )
            }
            {rightContainer ?
              <div
                key={'btn-right-container'}
                style={{ verticalAlign: 'middle', display: 'inline-block', marginLeft: 8 }}
                ref={btnLeftContainer => {
                  this.btnLeftContainer = btnLeftContainer
                }}
              /> : null
            }
          </div>
        </div>
      )

      return (
        <Container
          title={title}
          header={header}
          bodyStyle={bodyStyle}
          visible
          opened
          modal
          style={{ top: 20, padding: 0 }}
          dialogClass={`item-detail-modal custom-topbar ${dialogClass}`}
          onClose={() => this.props.onClose()}
          width={dialogWidth}
        >
          {remote.loadingItem && (
            <div style={{ padding: 40, textAlign: 'center' }}>
              <Spinner color="primary" />
            </div>
          )}

          {!remote.loadingItem && (
            <Formik
              innerRef={node => {
                this.form = node
              }}
              initialValues={remote.item}
              onSubmit={(values, formikHelpers  /* , { setSubmitting } */) => {
                if (apiResource === '/api/project_candidates') {
                  const submitErrors = {}

                  if (!values.curriculum) {
                    submitErrors.curriculum = 'Seleziona un candidato valido dalla lista.'
                  }

                  if (Object.keys(submitErrors).length > 0) {
                    formikHelpers.setErrors(submitErrors)
                    return
                  }

                  values.notaCandidato = values.notaCandidato ?? ''
                  values.profiloCandidato = values.profiloCandidato ?? ''
                }

                values.indeedMaxNumOfAds = parseInt(values.indeedMaxNumOfAds, 10) || 0;
                // this._onSubmit({values, closeModal: this.closeModal})
                if (remote.item.id && apiMethod === 'patch') {
                  values = differences(values, remote.item)
                  values.id = remote.item.id
                }
                remote.saveItem(values, (response) => {
                  // send event
                  this.props.socket.emit('room_events', {
                    room: this.roomName,
                    eventType: 'api:saved',
                    resource: response.data,
                  })
                  if (this.closeModal) {
                    this.props.onClose()
                  } else {
                    // eslint-disable-next-line no-unused-expressions
                    formikHelpers.setValues(response.data)
                  }
                }, (errorResponse) => {
                  if (errorResponse?.violations) {
                    const formikErrors = errorResponse.violations.reduce((acc, violation) => {
                      acc[violation.propertyPath] = violation.message
                      return acc
                    }, {})
                    formikHelpers.setErrors(formikErrors)
                  }
                })
              }}
            >
              {({ isSubmitting, ...props }) => (
                <>
                  <LastFormWrapped
                    form={props}
                    responseItem={remote.responseItem}
                    modalForm={{
                      setWidth: this._setWidth,
                      handleSave: this._save,
                      savingItem: remote.savingItem,
                      setValues: remote.onItemChange
                    }}
                    remote={{
                      setFieldValue: remote.setFieldValue,
                      extraData: remote.extraData,
                    }}
                    modal={rest}
                    ref={modalForm => {
                      this.modalForm = modalForm
                    }}
                  />
                  {this.btnLeftContainer &&
                    LeftButtons &&
                    ReactDOM.createPortal(
                      <LeftButtons
                        form={props}
                        remote={remote}
                        onSubmit={this._onSubmit}
                        onClose={this.props.onClose}
                      />,
                      this.btnLeftContainer
                    )}

                </>
              )}
            </Formik>
          )}
        </Container>
      )
    }
  }
  return compose(
    withRemoteActions({
      source,
      apiGetItemParams,
      apiResource,
      apiSaveUrl,
      savingFn,
      apiMethod,
      confirmDeleteMessage,
      getExtraData,
      getItemValues,
      onSavedProjectCv
    }),
    withSocket(),
  )(ModalForm)
}
